import React from "react";
// import bg from "../../../assets/images/aptech-assessment-and-testing-solutions-bg.png";
import styles from "./SectionComponent.module.scss";
import bg from "../../../assets/images/new-institution-sections.png";
import { Icon } from "../../../assets/Icons.tsx";
export default function SectionComponent({
  title,
  desc,
}: {
  title: string;
  desc: string;
}) {
  return (
    <div className="d-flex flex-column gap-3 align-items-center">
      <div
        style={{
          width: "100%",
          height: "230px",
          backgroundImage: `url(${bg})`,
          borderRadius: "20px",
        }}
        className="d-flex flex-row justify-content-center align-items-center"
      >
        <div className={styles.sectionTxtContainer}>
          <p
            style={{ color: "#FFF" }}
            className={`para text-center`}
            dangerouslySetInnerHTML={{ __html: title }}
          ></p>
        </div>
      </div>
      <p className="para" style={{ fontWeight: 700 }}>
        {desc}
      </p>
      <div className={styles.emailSection}>
        <Icon name="emailIcon" />
        <p className="para mb-0">
          Email:{" "}
          <a
            style={{ textDecoration: "none", color: "#036995" }}
            href={`mailto:${"reachus@aptech.co.in"}`}
          >
            reachus@aptech.co.in
          </a>
        </p>
      </div>
    </div>
  );
}
